import { __decorate } from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shallowequal from 'lodash/isEqual';
import Icon from '../icon';
import autobind from '../_util/autobind';
export default class ExpandIcon extends Component {
    shouldComponentUpdate(nextProps) {
        return !shallowequal(nextProps, this.props);
    }
    handleClick(e) {
        e.stopPropagation();
        const { onChange } = this.props;
        onChange(e);
    }
    render() {
        const { prefixCls, expanded, expandable } = this.props;
        const iconPrefixCls = `${prefixCls}-expand-icon`;
        const classString = classNames(iconPrefixCls, {
            [`${iconPrefixCls}-expanded`]: expanded,
            [`${iconPrefixCls}-spaced`]: !expandable,
        });
        return (React.createElement(Icon, { type: "baseline-arrow_right", className: classString, onClick: expandable ? this.handleClick : undefined, tabIndex: expandable ? 0 : -1 }));
    }
}
ExpandIcon.propTypes = {
    expandable: PropTypes.bool,
    expanded: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};
__decorate([
    autobind
], ExpandIcon.prototype, "handleClick", null);
